/*
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-05-19 09:49:33
 * @LastEditors: WangYuan
 * @LastEditTime: 2021-09-01 20:18:11
 */
import Vuex from 'vuex'
import user from './user'
import Vue from "vue";
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ...user.state,
  },
  getters: {
    ...user.getters,
  },
  mutations: {
    ...user.mutations,
  },
  actions: {
  },
  modules: {
  }
})
